import { LeadNote } from "./LeadNote";
import { CompanyPermission } from "./CompanyPermission";
import { ChannelType } from "../campaigns/ChannelType";

export interface Lead {
  Id: number;
  ClientStatusId?: number;
  AssetId: string;
  UserId?: number;
  CallIdExternal: string;
  ChannelId: number;
  CompanyId: number;
  GoogleKeywordId: number;
  ApiTypeId: number;
  ClientId: number;
  ClientStageIdOnCreate: number;
  ClientStageId: number;
  ProjectId?: number;

  AdCampaignIdExternal: string;
  AdCampaignNameExternal: string;
  AdGroupIdExternal: string;
  AdGroupNameExternal: string;
  AdIdExternal: string;
  AdNameExternal: string;
  ClientStatus: string;
  Address: string;
  DealAmount: number;
  AssetTitle: string;
  AssigneeName: string;
  Process: string;
  CallSeconds: number;
  CallSecondsStr: string;
  CallStatus: string;
  CampaignTitle: string;
  MetadataTypeIdFromChannel: ChannelType;
  MetadataTypeFromChannel: string;
  ChannelTitle: string;
  Company: string;
  CreateDate: Date;
  CreditCardProblem?: boolean;
  Data: string;
  DealStr: string;
  Deleted: boolean;
  Email: string;
  ExternalCrmId: number;
  Favourite: boolean;
  FormUrl: string;
  MetadataTypeIdFromUrl: ChannelType;
  MetadataTypeFromUrl: string;
  FullName: string;
  IsBad: boolean;
  IsCalculatedLead: boolean;
  IsClosed: boolean;
  IsInProcess: boolean;
  IsUnique: boolean;
  Keyword: string;
  ApiType: string;
  ClientStageOnCreate: string;
  Meeting: boolean;
  MeetingStr: string;
  Note: string;
  Phone: string;
  Price: number;
  ProjectTitle: string;
  SaleStatus: string;
  Status: string;
  StatusCall?: number;
  Tag: string;
  ToPhone: string;
  UrlReferrer: string | null;
  UserIp: string;
}

export interface ClientEditViewModel {
  EditAllLeads: boolean;
  IsLeadViewer: boolean;
  IsShared: boolean;
  ShowDealsAmount: boolean;
  ShowEmail: boolean;
  ShowFullname: boolean;
  ShowOtherData: boolean;
  ShowPhone: boolean;
  ShowPrice: boolean;
  ShowSalesman: boolean;
  Client: Lead;
  ActiveRestictions: CompanyPermission[];
  LeadNotes: LeadNote[];
}

export interface LeadEditViewModel {
  EditAllLeads: boolean;
  IsLeadViewer: boolean;
  IsShared: boolean;
  ShowDealsAmount: boolean;
  ShowEmail: boolean;
  ShowFullname: boolean;
  ShowOtherData: boolean;
  ShowPhone: boolean;
  ShowPrice: boolean;
  ShowSalesman: boolean;
  ContactForm: Lead;
  ActiveRestictions: CompanyPermission[];
  LeadNotes: LeadNote[];
}

export interface LeadsPageViewModel {
  CompanyId: number;
  AgencyId?: number;
  CanDeleteLeads: boolean;
  EditAllLeads: boolean;
  ShowAllLeads: boolean;
  ShowDealsAmount: boolean;
  ShowEmail: boolean;
  ShowFullname: boolean;
  ShowOtherData: boolean;
  ShowPhone: boolean;
  ShowPrice: boolean;
  ShowSalesman: boolean;
  ActiveRestictions: CompanyPermission[];
}

export interface UpdateLeadResponse {
  message: string;
  success: boolean;
  status: string;
}

export enum RefreshGridMode {
  None,
  Full,
  GraphsOnly,
  GridOnly
}

export enum ToggleLeadEditMode {
  None,
  Notes
}

export interface PhonePopupData {
    showPopup: boolean;
    message?: string;
}
